import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import JSZip from "jszip";
import {mediaFormatDimensions} from "../../../config/mediaFormatDimensions";

const IFRAME_ID = 'PLAYER_IFRAME';

const CreationEmbedPreview = () => {
    const [searchParams] = useSearchParams();
    const mediaFormat = searchParams.get('mediaFormat');
    const [mediaDimensions, setMediaDimensions] = useState({width: 0, height: 0});


    useEffect(() => {
            setMediaDimensions({width: mediaFormatDimensions[mediaFormat as keyof typeof mediaFormatDimensions][0], height:  mediaFormatDimensions[mediaFormat as keyof typeof mediaFormatDimensions][1]});
        },
        [mediaFormat])

    const fetchZipFileUrl = async () => {
        try {
            const response = await fetch(searchParams.get('fileUrl') || '');
            if (!response.ok) {
                throw new Error('Failed to download the file');
            }
            return await response.blob();
        } catch (error) {
            console.error('Error while downloading the file:', error);
        }
    }

    const writeIframeDocument = (files: any) => {
        const currentIframe = document.getElementById(IFRAME_ID) as HTMLIFrameElement;
        const htmlFileName = Object.keys(files).find(fileName => fileName.endsWith('.html'));
        const iframeDoc = currentIframe?.contentDocument || currentIframe?.contentWindow?.document;

        if (currentIframe && iframeDoc && htmlFileName) {
            iframeDoc.open();
            iframeDoc.write(replaceMediaUrlsInHtml(files[htmlFileName], files));
            iframeDoc.close();
        }
    }

    function replaceMediaUrlsInHtml(htmlContent: string, files: any) {
        return htmlContent.replace(/(src|href)=['"]?([^'"]+)['"]?/g, (match: any, attr: any, mediaPath: any) => {
            const mediaFileName = mediaPath.split('/').pop();
            if (files[mediaFileName]) {
                if (mediaFileName.endsWith('.svg')) {
                    return `${attr}="data:image/svg+xml;base64,${btoa(files[mediaFileName])}"`;
                } else if (mediaFileName.endsWith('.css')) {
                    const cssTextWithUrlsReplaced = replaceMediaUrlsInCss(files[mediaFileName], files);
                    return `${attr}="data:text/css;base64,${btoa(cssTextWithUrlsReplaced)}"`;
                } else {
                    const mediaBlob = files[mediaFileName];
                    const mediaUrl = URL.createObjectURL(mediaBlob);
                    return `${attr}="${mediaUrl}"`;
                }
            }
            return match;
        });
    }

    function replaceMediaUrlsInCss(cssText: string, files: any) {
        return cssText.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, mediaPath) => {
            const mediaFileName = mediaPath.split('/').pop();
            if (files[mediaFileName]) {
                const mediaBlob = files[mediaFileName];
                const mediaUrl = URL.createObjectURL(mediaBlob);
                return `url(${mediaUrl})`;
            }
            return match;
        });
    }

    useEffect(() => {
        fetchZipFileUrl().then(async (blob) => {
            if (!blob) return;
            const files: any = {};
            const zip = await JSZip.loadAsync(blob);
            for (const fileName of Object.keys(zip.files)) {
                const file = zip.files[fileName];
                if (!file.dir) {
                    const content = fileName.endsWith('.svg') || fileName.endsWith('.css') || fileName.endsWith('.html')
                        ? await file.async("text")
                        : await file.async("blob");
                    files[fileName] = content;
                }
            }
            writeIframeDocument(files);
        });
    }, [searchParams, mediaFormat]);

    return (
        <div className={''} id={'wrapper-outside'}>
            <iframe
                id={IFRAME_ID}
                height={mediaDimensions.height}
                width={mediaDimensions.width}
            />
        </div>
    );
}

export default CreationEmbedPreview;
